import { Checkbox } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../CustomSharedButton/CustomSharedButton";
import CustomModal from "../CustomSharedModal/CustomSharedModal";

interface PrivacyPolicyModalProps {
  open: boolean;
  appName: string;
  isFirstAccess: boolean;
  firstParagraph?: string;
  policyDate?: string;
  accepting?: boolean;
  onOpenPolicy: () => void;
  onAccept: () => void;
}

function PrivacyPolicyModal({
  open,
  appName,
  isFirstAccess,
  firstParagraph,
  policyDate,
  accepting = false,
  onOpenPolicy,
  onAccept,
}: PrivacyPolicyModalProps) {
  const { t } = useTranslation();
  const [consentChecked, setConsentChecked] = useState(false);

  useEffect(() => {
    setConsentChecked(false);
  }, [open, isFirstAccess, policyDate]);

  return (
    <CustomModal
      open={open}
      centered
      width={730}
      zIndex={3000}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      styles={{ content: { padding: 32 } }}
      aria-labelledby="privacy-policy-modal-title"
    >
      <div className="text-center">
        <h2
          id="privacy-policy-modal-title"
          className="mb-6 text-[20px] font-bold leading-8 text-black"
        >
          {isFirstAccess
            ? t("privacy_policy_welcome", { appName })
            : t("privacy_policy_updated_title")}
        </h2>

        {isFirstAccess && (
          <>
            <p className="mb-7 text-left text-[16px] leading-5 text-gray9">
              {t("privacy_policy_first_access_intro")}
            </p>
            {firstParagraph && (
              <p className="mb-8 text-left text-[14px] leading-5 text-gray10">
                {firstParagraph}
              </p>
            )}
          </>
        )}

        <div className="flex flex-col gap-4">
          <CustomButton
            type="secondary"
            buttonSize="big"
            className="w-full"
            label={
              isFirstAccess
                ? t("privacy_policy_open")
                : policyDate
                  ? t("privacy_policy_open_updated_dated", {
                      date: policyDate,
                    })
                  : t("privacy_policy_open_updated")
            }
            onClick={onOpenPolicy}
          />
          {!isFirstAccess && <hr className="border-gray4" />}
          <Checkbox
            className="self-start text-left font-semibold"
            checked={consentChecked}
            disabled={accepting}
            onChange={(event) => setConsentChecked(event.target.checked)}
          >
            {t("privacy_policy_accept")}
          </Checkbox>
          <CustomButton
            type="primary"
            buttonSize="big"
            className="w-full"
            label={t("next")}
            disabled={!consentChecked || accepting}
            loading={accepting}
            onClick={() => {
              if (consentChecked && !accepting) onAccept();
            }}
          />
        </div>
      </div>
    </CustomModal>
  );
}

export default PrivacyPolicyModal;
